import React, { useState, useEffect, createContext } from 'react';
import { useHistory } from 'react-router-dom';
import useFirebase from '../Firebase';
import LoadingScreen from '../Loading';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState({
    authenticated: false
  });
  const firebase = useFirebase();
  const history = useHistory();
  console.debug('calling AuthProvider', user);

  const signIn = (e, p) =>
    firebase
      .doSignInWithEmailAndPassword(e, p)
      .then(userCredential => {
        return firebase.user(userCredential.user.uid).get();
      })
      .then(doc => {
        setUser({
          ...doc.data(),
          authenticated: true
        });
      });

  useEffect(() => {
    if (firebase) {
      setLoading(true);
      const subscriber = firebase.auth.onAuthStateChanged(authUser => {
        if (authUser) {
          console.debug('authuser', authUser);
          setUser({ uid: authUser.uid, authenticated: true, user: authUser });
          firebase
            .user(authUser.uid)
            .get()
            .then(doc => {
              let user = {
                ...doc.data(),
                uid: authUser.uid,
                authenticated: true,
                user: authUser
              };
              setUser(user);
              setLoading(false);
            });
        } else {
          setUser({
            authenticated: false
          });
          setLoading(false);
        }
      });
      return subscriber;
    }
  }, [firebase, history]);

  if (loading) return <LoadingScreen open={loading} />;
  return (
    <AuthContext.Provider value={{ ...user, signIn: signIn }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
